interface HtmlEditorProps {
  value: string
  onChange: (val: string) => void
}

export function HtmlEditor({ value, onChange }: HtmlEditorProps) {
  return (
    <>
      <div className="html-editor-wrap">
        <div className="html-editor-toolbar">
          <span className="html-editor-lang">HTML</span>
          <span className="html-editor-hint">Edit raw HTML. Changes sync to WYSIWYG.</span>
        </div>
        <textarea
          className="html-editor"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          spellCheck={false}
          autoCapitalize="off"
          autoCorrect="off"
        />
      </div>

      <style>{`
        .html-editor-wrap {
          border: 1px solid var(--border);
          border-radius: var(--radius-md);
          overflow: hidden;
        }
        .html-editor-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 7px 14px;
          background: var(--bg-surface);
          border-bottom: 1px solid var(--border);
        }
        .html-editor-lang {
          font-family: var(--font-mono);
          font-size: 0.7rem;
          font-weight: 700;
          color: var(--color-info);
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }
        .html-editor-hint {
          font-size: 0.72rem;
          color: var(--text-muted);
        }
        .html-editor {
          display: block;
          width: 100%;
          min-height: 420px;
          padding: 14px 16px;
          background: var(--bg-input);
          color: var(--text-primary);
          font-family: var(--font-mono);
          font-size: 0.82rem;
          line-height: 1.7;
          resize: vertical;
          border: none;
          outline: none;
          tab-size: 2;
        }
        .html-editor::placeholder { color: var(--text-muted); }
      `}</style>
    </>
  )
}
